import tremor from "refractor/tremor";
export default tremor;